import { createSlice } from "@reduxjs/toolkit";
import {
  deleteCategory,
  getAllCategory,
  getCategory,
  undoDeleteCategory,
} from "./category.api";

const surnameSlice = createSlice({
  name: "category",
  initialState: {
    category: [],
    categories: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.category = action.payload;
      state.dataLimit = action.payload?.meta?.limit || 0;
      state.currentPage = action.payload?.meta?.page || 1;
      state.totalPages = action.payload?.meta?.totalPages || 0;
      state.totalData = action.payload?.meta?.total || 0;
    });
    builder.addCase(getCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getAllCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllCategory.fulfilled, (state, action) => {
      state.loading = false;

      state.categories = action.payload.data;
    });
    builder.addCase(getAllCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteCategory.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.category.data) {
        state.category.data = state.category.data.filter((category) => {
          return category._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.category.data is not an array:",
          state.category.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteCategory.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.category.data) {
        state.category.data = state.category.data.filter((category) => {
          return category._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.category.data is not an array:",
          state.category.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = surnameSlice.actions;
export default surnameSlice.reducer;
